import { Fragment } from "react";
import StaedteError from "./Error";

export default function EventInfos( params ) {

    const eventData = params.data;

    let errorOccured = undefined !== eventData.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === eventData || 0 === eventData.length ) {
        return;
    }

    let howWorksTheEventText = '';
    switch( eventData.event ) {
        case 'BDPL':
            howWorksTheEventText = window.staedteFrontendShortcodeData.i18n.howWorksTheBeerDiplom;
        case 'CBSC':
            howWorksTheEventText = window.staedteFrontendShortcodeData.i18n.howWorksTheCocktailBachelor;
        case 'BBSC':
        default:
            howWorksTheEventText = window.staedteFrontendShortcodeData.i18n.howWorksTheBeerBachelor;
        
    }

    return(
        <>
            <div style={{marginTop: "50px"}}>


                
                


            </div>

            <div style={{marginTop: "50px"}}>

                <p className="mb-3" style={{fontSize: "1.5em",margin: "0px 0px 20px 0px"}}>
                    <b>
                        {howWorksTheEventText}
                    </b>
                </p>

                <div style={{ color:"#5e5e5e"}}>
                    <p className="pb-0">
                        {window.staedteFrontendShortcodeData.i18n.eventExplanation.part_0}<br />
                        {window.staedteFrontendShortcodeData.i18n.eventExplanation.part_1}<br />
                        {window.staedteFrontendShortcodeData.i18n.eventExplanation.part_2}<br />
                        {window.staedteFrontendShortcodeData.i18n.eventExplanation.part_3}<br />
                    </p>
                    <p className="mt-1 mb-1 pb-0">
                        <b style={{color:"black"}}>
                            {window.staedteFrontendShortcodeData.i18n.eventExplanation.part_4}
                        </b>
                    </p>
                    <p>
                        {window.staedteFrontendShortcodeData.i18n.eventExplanation.part_5}
                    </p>
                </div>

                <div
                    style={{
                        margin: "40px 0px 0px 0px",
                        display: "flex",
                        justifyContent: "center"
                    }}
                    className="staedte-event-missed-buttons-container"
                >

                    <form id="button-form-verpasst" method="get" action="" >
                        <input id="button-verpasst" type="submit" value={window.staedteFrontendShortcodeData.i18n.moreEventInfos} />
                    </form>
            
                    <form id="button-form-verpasst" method="get" action="">
                        <input id="button-verpasst" type="submit" value={window.staedteFrontendShortcodeData.i18n.toFAQ} />
                    </form>

                </div>

            </div>
        </>
    )

}